// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","wolf":"Logo_wolf__2Tt2k"};